import React, { FC } from "react";
import { faCodeBranch } from "@fortawesome/pro-solid-svg-icons";
import { Box, HoverCard, ScrollArea, Stack, Text } from "@mantine/core";

import { CodeLocationIcon } from "./CodeLocationIcon";

type BranchIconProps = {
  branchName: string;
  branchHref?: string;
  allOtherBranchNames?: string[];
};

export const BranchIcon: FC<BranchIconProps> = ({
  branchName,
  branchHref,
  allOtherBranchNames,
}) => {
  return (
    <HoverCard withArrow withinPortal position="top" shadow="md">
      <HoverCard.Target>
        <Box>
          <CodeLocationIcon
            label={
              allOtherBranchNames && allOtherBranchNames.length > 0
                ? `${branchName} +${allOtherBranchNames.length}`
                : branchName
            }
            href={branchHref}
            icon={faCodeBranch}
          />
        </Box>
      </HoverCard.Target>
      {allOtherBranchNames && allOtherBranchNames.length > 0 && (
        <HoverCard.Dropdown maw="30em">
          <ScrollArea.Autosize mah={250}>
            <Stack gap={1}>
              <Text fz="xs" fw="bold">
                Seen on:
              </Text>
              <Text fz="xs">{branchName}</Text>
              {allOtherBranchNames.map((b, _) => (
                <Text key={b} fz="xs">
                  {b}
                </Text>
              ))}
            </Stack>
          </ScrollArea.Autosize>
        </HoverCard.Dropdown>
      )}
    </HoverCard>
  );
};
